export default "__VITE_ASSET__CugfHJlV__"